export enum EventStatus {
    SEEN = 'SEEN',
    NEW = 'NEW',
}
